<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('job_fair_management.cv_bank') }} {{ $t('globalTrans.search') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
          <b-col xs="4" sm="4" md="4" lg="4" xl="4">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  :label="$t('globalTrans.name')"
                  label-for="name"
                  >
                  <b-form-input
                  v-model="search.name"
                  id="name"
                  >
                  </b-form-input>
              </b-form-group>
          </b-col>
          <b-col xs="4" sm="4" md="4" lg="4" xl="4">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  :label="$t('externalUser.mobile_no')"
                  label-for="mobile"
                  >
                  <b-form-input
                  v-model="search.mobile"
                  id="mobile"
                  >
                  </b-form-input>
              </b-form-group>
          </b-col>
          <b-col xs="4" sm="4" md="4" lg="4" xl="4">
                <ValidationProvider name="Division" vid="division_id" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="division_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.division')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="search.division_id"
                            :options="divisionList"
                            id="division_id"
                            @change="getDistrictList(search.division_id)"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
          </b-col>

            <!-- District -->
          <b-col xs="4" sm="4" md="4" lg="4" xl="4">
                <ValidationProvider name="District" vid="district_id" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="district_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.district')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="search.district_id"
                            :options="districtList"
                            id="district_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">
                <ValidationProvider name="Educational Qualification" vid="educational_qualification" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="educational_qualification"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('consultancy_therapy_center.educational_qualification')}}<span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="search.educational_qualification"
                            :options="educationalQualificationList"
                            id="division_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
             </b-col>
             <b-col xs="12" sm="12" md="2" lg="2" xl="2">
                    <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
             </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('job_fair_management.cv_bank') }} {{ $t('globalTrans.list') }} </h4>
          </template>
          <template v-slot:headerAction>
            <router-link to="cv-bank-form" :class="'btn btn-success text-light'">{{  $t('globalTrans.add_new') }}</router-link>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(year)="data">
                      {{ $n(data.item.year, { useGrouping : false }) }}
                    </template>
                    <template v-slot:cell(from_date)="data">
                      {{ data.item.from_date | dateFormat }}
                    </template>
                    <template v-slot:cell(mobile)="data">
                      {{ data.item.mobile | mobileNumber }}
                    </template>
                    <template v-slot:cell(nid)="data">
                      {{ $n(data.item.nid, { useGrouping: false }) }}
                    </template>
                    <template v-slot:cell(to_date)="data">
                      {{ data.item.to_date | dateFormat }}
                    </template>
                    <template v-slot:cell(status)="data">
                        <span class="badge badge-danger" v-if="data.item.status == 2">{{$t('globalTrans.inactive')}}</span>
                        <span class="badge badge-success" v-else>{{$t('globalTrans.active')}}</span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <!-- <b-button v-b-modal.modal-4 variant=" iq-bg-success mr-1 mb-1" size="sm" title="Edit" @click="edit(data.item)"><i class="ri-ball-pen-fill m-0"></i></b-button> -->
                      <router-link title="Edit" :to="`/awareness-event-service/job-fair-management/cv-bank-form?id=${data.item.id}`" class="btn btn-sm btn-warning"><i class="ri-ball-pen-fill m-0"></i></router-link>
                      <!-- <b-button class="mr-2" title="View Details" v-b-modal.modal-detail variant=" iq-bg-success border-info" size="sm" @click="view(data.item)"><i class="ri-eye-line m-0 "></i></b-button> -->
                      <router-link title="View Details" :to="`/awareness-event-service/job-fair-management/cv-bank-details?id=${data.item.id}`" class="btn btn-sm btn-info ml-2"><i class="ri-eye-line m-0 "></i></router-link>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-4" size="xl" :title="formTitle" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <p>
        <FormV :id="editItemId" :key="editItemId" :item="item"/>
      </p>
    </b-modal>
    <b-modal id="modal-detail" size="lg" :title="detailTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <DetailModal :id="viewitemId" :key="viewitemId"  :item="viewitemId"/>
    </b-modal>

  </b-container>
</template>
<script>
// import FormV from './Form'
import DetailModal from './Details'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { patientCvBankListApi, jobFairCirculationToggleStatusApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import { helpers } from '@/mixins/helper-functions'
import flatpickr from 'flatpickr'

export default {
    mixins: [ModalBaseMasterList],
    components: {
        // FormV, DetailModal
        DetailModal
    },
    data () {
        return {
            search: {
                name: '',
                mobile: '',
                division_id: 0,
                district_id: 0,
                educational_qualification: ''
            },
            editItemId: '',
            viewitemId: 0,
            hosId: '',
            item: '',
            rows: [],
            districtList: [],
            patientCategoryList: [],
            serviceTypeList: []
        }
    },
    computed: {
      getServiceTypeList: function () {
            const objectData = this.$store.state.AwarenessEventService.commonObj.serviceTypeList.filter(item => item.status === 1)
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
      },
      detailTitle () {
        return this.$t('job_fair_management.job_fair_circulation') + ' ' + this.$t('globalTrans.details')
      },
      formTitle () {
        return (this.editItemId === 0) ? this.$t('job_fair_management.job_fair_circulation') + ' ' + this.$t('globalTrans.entry') : this.$t('job_fair_management.job_fair_circulation') + ' ' + this.$t('globalTrans.modify')
      },
      columns () {
          const labels = [
            { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
            { label: this.$t('globalTrans.name'), class: 'text-left' },
            { label: this.$t('globalTrans.father_name'), class: 'text-left' },
            { label: this.$t('globalTrans.mother_name'), class: 'text-left' },
            { label: this.$t('job_fair_management.nid'), class: 'text-left' },
            { label: this.$t('globalTrans.mobile_no'), class: 'text-left' },
            { label: this.$t('globalTrans.action'), class: 'text-center' }
          ]

          let keys = []

          if (this.$i18n.locale === 'bn') {
              keys = [
                  { key: 'index' },
                  { key: 'name_bn' },
                  { key: 'father_name_bn' },
                  { key: 'mother_name_bn' },
                  { key: 'nid' },
                  { key: 'mobile' },
                  { key: 'action' }
              ]
          } else {
              keys = [
                  { key: 'index' },
                  { key: 'name' },
                  { key: 'father_name' },
                  { key: 'mother_name' },
                  { key: 'nid' },
                  { key: 'mobile' },
                  { key: 'action' }
              ]
          }

          return labels.map((item, index) => {
              return Object.assign(item, keys[index])
          })
      },
      yearList () {
        return helpers.getYearList()
      },
      divisionList: function () {
        return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
      },
      educationalQualificationList: function () {
        const objectData = this.$store.state.ExternalUser.hospitalCommonObj.educationalQualificationList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
      }
    },
    watch: {
    },
    created () {
        this.loadData()
    },
    mounted () {
      flatpickr('.date-picker', {})
    },
    methods: {
        searchData () {
            this.loadData()
        },
        changeDivisionId (divisionId) {
            this.search.district_id = 0
            this.districtList = this.getDistrictList(divisionId)
        },
        getDistrictList (divisionId = null) {
            const objectData = this.$store.state.ExternalUser.commonObj.districtList.filter(item => item.status === 0 && item.division_id === parseInt(this.search.division_id))
            objectData.map((obj) => {
                if (this.$i18n.locale === 'bn') {
                    obj.text = obj.text_bn
                } else {
                    obj.text = obj.text_en
                }
            })
            this.districtList = objectData
        },
        edit (item) {
            this.editItemId = item.id
            this.item = item
        },
         view (viewitem) {
          this.viewitemId = viewitem
        },
        remove (item) {
            this.changeStatus(awarenessEventServiceBaseUrl, jobFairCirculationToggleStatusApi, item)
        },
        loadData () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
            RestApi.getData(awarenessEventServiceBaseUrl, patientCvBankListApi, params).then(response => {
                if (response.success) {
                    // this.$store.dispatch('setList', this.getRelationalData(response.data.data))
                    this.$store.dispatch('setList', response.data.data)
                    this.paginationData(response.data)
                }
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            })
        },
         getServiceName (id) {
            const objectData = this.$store.state.AwarenessEventService.commonObj.serviceTypeList.find(item => item.value === parseInt(id))
                return objectData.value
        },
        getRelationalData (data) {
            let serviceList = {}
            let patientList = {}
            const listData = data.map(item => {
                serviceList = this.$store.state.AwarenessEventService.commonObj.serviceTypeList.find(service => service.value === item.service_type_id)
                patientList = this.$store.state.AwarenessEventService.commonObj.patientCategoryList.find(service => service.value === item.patient_category_id)
                const list = {
                    type_name: serviceList !== undefined ? serviceList.text_en : '',
                    type_name_bn: serviceList !== undefined ? serviceList.text_bn : '',
                    category_name: patientList !== undefined ? patientList.text_en : '',
                    category_name_bn: patientList !== undefined ? patientList.text_bn : ''
                }
                return Object.assign({}, item, list)
            })
            return listData
        }
    }
}
</script>
